import { render, staticRenderFns } from "./modObservacion.vue?vue&type=template&id=0325e49c&"
import script from "./modObservacion.vue?vue&type=script&lang=js&"
export * from "./modObservacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports